(function () {
  function initPhaseIngredients(root) {
    if (!root || root.dataset.eePhaseIngredientsInit === 'true') return;

    var tabs = root.querySelectorAll('[data-ee-pi-tab]');
    var panels = root.querySelectorAll('[data-ee-pi-panel]');
    if (!tabs.length || !panels.length) return;

    root.dataset.eePhaseIngredientsInit = 'true';

    function activateTab(tab) {
      var targetId = tab.getAttribute('data-ee-pi-tab');

      tabs.forEach(function (item) {
        var isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-ee-pi-panel') !== targetId;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });

      tab.addEventListener('keydown', function (event) {
        var currentIndex = Array.prototype.indexOf.call(tabs, tab);
        var nextIndex = currentIndex;

        if (event.key === 'ArrowRight') {
          nextIndex = (currentIndex + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        activateTab(tabs[nextIndex]);
        tabs[nextIndex].focus();
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ee-phase-ingredients]').forEach(initPhaseIngredients);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ee-phase-ingredients]');
    if (root) initPhaseIngredients(root);
  });
})();
